import { render, staticRenderFns } from "./WorkOrderForm.vue?vue&type=template&id=31f4bbbe&scoped=true&"
import script from "./WorkOrderForm.vue?vue&type=script&lang=js&"
export * from "./WorkOrderForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkOrderForm.vue?vue&type=style&index=0&id=31f4bbbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f4bbbe",
  null
  
)

export default component.exports